function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: inherit;\n  font-weight: 500;\n  transition: all 0.2s;\n  cursor: pointer;\n  border: none;\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px var(--theme-primary);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    pointer-events: none;\n  }\n  \n  // 아이콘 색상이 항상 버튼 텍스트 색상을 따르도록 설정\n  svg {\n    color: currentColor;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    background-color: var(--theme-primary);\n    color: var(--theme-primary-text);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    border: none;\n    \n    &:hover {\n      background-color: var(--theme-primary-dark);\n      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    }\n    \n    &:active {\n      background-color: var(--theme-primary-darker, #1d4ed8);\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n    }\n  "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    background-color: var(--theme-secondary);\n    color: var(--theme-secondary-text);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    border: none;\n    \n    &:hover {\n      opacity: 0.9;\n      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    }\n    \n    &:active {\n      opacity: 0.7;\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n    }\n  "
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    border: 2px solid var(--theme-border);\n    background-color: transparent;\n    color: var(--theme-text);\n    \n    &:hover {\n      background-color: var(--theme-paper-hover);\n    }\n    \n    &:active {\n      background-color: var(--theme-paper-active);\n      border-color: var(--theme-border-dark, #9ca3af);\n    }\n  "
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    background-color: transparent;\n    border: none;\n    color: var(--theme-text-secondary);\n    \n    &:hover {\n      background-color: var(--theme-paper-hover);\n    }\n    \n    &:active {\n      background-color: var(--theme-paper-active);\n    }\n    \n    // 특별히 아이콘만 있는 버튼을 위한 테마 처리\n    &[aria-label] {\n      svg {\n        color: currentColor;\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    background-color: var(--theme-danger);\n    color: var(--theme-danger-text);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    border: none;\n    \n    &:hover {\n      background-color: var(--theme-danger-dark);\n      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    }\n    \n    &:active {\n      background-color: var(--theme-danger-darker, #b91c1c);\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n    }\n  "
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n    color: var(--theme-text-muted);\n    background-color: transparent;\n    border: none;\n    \n    &:hover {\n      color: var(--theme-text);\n      background-color: var(--theme-paper-hover);\n    }\n  "
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n    font-size: 0.75rem; // 12px\n    padding: 0.375rem 0.625rem; // 6px 10px\n  "
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n    font-size: 0.875rem; // 14px\n    padding: 0.5rem 0.75rem; // 8px 12px\n  "
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n    font-size: 0.875rem; // 14px\n    padding: 0.5rem 1rem; // 8px 16px\n\n    @media (max-width: ",
        ") {\n      font-size: 0.875rem; // 14px (sm 크기 기준)\n      padding: 0.5rem 0.75rem; // 8px 12px (sm 크기 기준)\n    }\n  "
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n    font-size: 1rem; // 16px\n    padding: 0.625rem 1.25rem; // 10px 20px\n\n    @media (max-width: ",
        ") {\n      font-size: 0.875rem; // 14px (md 크기 기준)\n      padding: 0.5rem 1rem; // 8px 16px (md 크기 기준)\n    }\n  "
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n    font-size: 1.125rem; // 18px\n    padding: 0.75rem 1.5rem; // 12px 24px\n\n    @media (max-width: ",
        ") {\n      font-size: 1rem; // 16px (lg 크기 기준)\n      padding: 0.625rem 1.25rem; // 10px 20px (lg 크기 기준)\n    }\n  "
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n    border-radius: 0;\n  "
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n    border-radius: 0.125rem;\n  "
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n    border-radius: 0.375rem;\n  "
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n    border-radius: 0.5rem;\n  "
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n    border-radius: 9999px;\n  "
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n    transform-origin: center;\n    \n    &:hover {\n      transform: scale(1.05);\n    }\n    \n    &:active {\n      transform: scale(0.95);\n    }\n  "
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n    padding: 0.25rem; // 4px\n    width: 1.5rem; // 24px\n    height: 1.5rem; // 24px\n  "
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n    padding: 0.375rem; // 6px\n    width: 1.75rem; // 28px\n    height: 1.75rem; // 28px\n  "
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n    padding: 0.375rem; // 6px\n    width: 2rem; // 32px\n    height: 2rem; // 32px\n\n    @media (max-width: ",
        ") {\n      padding: 0.375rem; // 6px (sm 크기 기준)\n      width: 1.75rem; // 28px (sm 크기 기준)\n      height: 1.75rem; // 28px (sm 크기 기준)\n    }\n  "
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n    padding: 0.5rem; // 8px\n    width: 2.25rem; // 36px\n    height: 2.25rem; // 36px\n\n    @media (max-width: ",
        ") {\n      padding: 0.375rem; // 6px (md 크기 기준)\n      width: 2rem; // 32px (md 크기 기준)\n      height: 2rem; // 32px (md 크기 기준)\n    }\n  "
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n    padding: 0.625rem; // 10px\n    width: 2.5rem; // 40px\n    height: 2.5rem; // 40px\n\n    @media (max-width: ",
        ") {\n      padding: 0.5rem; // 8px (lg 크기 기준)\n      width: 2.25rem; // 36px (lg 크기 기준)\n      height: 2.25rem; // 36px (lg 크기 기준)\n    }\n  "
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n    width: 100%;\n  "
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n    min-width: ",
        "px;\n  "
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  \n  // 테마 변환에 반응하는 전역 스타일\n  transition: all 0.2s ease, background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n  \n  // 변형(variant) 스타일 적용\n  ",
        "\n  \n  // 크기(size) 스타일 적용\n  ",
        "\n  \n  // iconOnly 크기 스타일 적용\n  ",
        "\n  \n  // 너비(fullWidth) 스타일 적용\n  ",
        "\n  \n  // 최소 너비(minWidth) 스타일 적용\n  ",
        "\n  \n  // 모양(shape) 스타일 적용\n  ",
        "\n  \n  // 애니메이션(animation) 스타일 적용\n  ",
        '\n  \n  // VSCode 환경에서의 대응\n  body.vscode-dark &, .vscode-dark & {\n    // VSCode 다크모드에서 스타일을 오버라이드\n    &[class*="primary"] {\n      background-color: var(--vscode-button-background);\n      color: var(--vscode-button-foreground);\n      \n      &:hover {\n        background-color: var(--vscode-button-hoverBackground);\n      }\n    }\n    \n    &[class*="secondary"] {\n      background-color: var(--vscode-button-secondaryBackground);\n      color: var(--vscode-button-secondaryForeground);\n      \n      &:hover {\n        background-color: var(--vscode-button-secondaryHoverBackground);\n      }\n    }\n    \n    &[class*="ghost"], &[class*="outline"] {\n      color: var(--vscode-foreground);\n      border-color: var(--vscode-editorGroup-border);\n      \n      &:hover {\n        background-color: rgba(255, 255, 255, 0.1);\n      }\n    }\n  }\n'
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  animation: spin 1s linear infinite;\n  margin-right: 0.5rem;\n  width: 1rem;\n  height: 1rem;\n  \n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n    margin-right: 0.5rem;\n  "
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n    margin-left: 0.5rem;\n  "
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  ",
        "\n  \n  ",
        "\n  \n  svg {\n    width: 1em;\n    height: 1em;\n  }\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { defaultTheme } from '../../../../types/theme';
// 버튼 베이스 스타일
var baseButtonStyles = css(_templateObject());
// 버튼 변형(variant) 스타일
var variantStyles = {
    primary: css(_templateObject1()),
    secondary: css(_templateObject2()),
    outline: css(_templateObject3()),
    ghost: css(_templateObject4()),
    danger: css(_templateObject5()),
    default: css(_templateObject6())
};
// 버튼 크기 스타일 (반응형 추가)
var sizeStyles = {
    xs: css(_templateObject7()),
    sm: css(_templateObject8()),
    md: function(theme) {
        return css(_templateObject9(), theme.breakpoints.sm);
    },
    lg: function(theme) {
        return css(_templateObject10(), theme.breakpoints.sm);
    },
    xl: function(theme) {
        return css(_templateObject11(), theme.breakpoints.sm);
    }
};
// 버튼 모양 스타일
var shapeStyles = {
    flat: css(_templateObject12()),
    soft: css(_templateObject13()),
    rounded: css(_templateObject14()),
    pill: css(_templateObject15()),
    circular: css(_templateObject16())
};
// 버튼 애니메이션 스타일
var animationStyles = {
    scale: css(_templateObject17()),
    none: css(_templateObject18())
};
// IconOnly 버튼 크기 스타일 (반응형 추가)
var iconOnlySizeStyles = {
    xs: css(_templateObject19()),
    sm: css(_templateObject20()),
    md: function(theme) {
        return css(_templateObject21(), theme.breakpoints.sm);
    },
    lg: function(theme) {
        return css(_templateObject22(), theme.breakpoints.sm);
    },
    xl: function(theme) {
        return css(_templateObject23(), theme.breakpoints.sm);
    }
};
// 버튼 스타일 컴포넌트
export var StyledButton = styled.button(_templateObject26(), baseButtonStyles, function(props) {
    return props.$variant && variantStyles[props.$variant];
}, function(props) {
    var theme = props.theme || defaultTheme;
    if (props.$size && !props.$iconOnly) {
        var sizeStyle = sizeStyles[props.$size];
        return typeof sizeStyle === 'function' ? sizeStyle(theme) : sizeStyle;
    }
    return '';
}, function(props) {
    var theme = props.theme || defaultTheme;
    if (props.$iconOnly && props.$size) {
        var iconSizeStyle = iconOnlySizeStyles[props.$size];
        return typeof iconSizeStyle === 'function' ? iconSizeStyle(theme) : iconSizeStyle;
    }
    return '';
}, function(props) {
    return props.$fullWidth && css(_templateObject24());
}, function(props) {
    return props.$minWidth && css(_templateObject25(), props.$minWidth);
}, function(props) {
    return props.$shape && shapeStyles[props.$shape];
}, function(props) {
    return props.$animation && animationStyles[props.$animation];
});
// 로딩 아이콘 스타일
export var LoaderIcon = styled.svg(_templateObject27());
// 아이콘 컨테이너 스타일
export var IconContainer = styled.span(_templateObject30(), function(props) {
    return props.$position === 'left' && css(_templateObject28());
}, function(props) {
    return props.$position === 'right' && css(_templateObject29());
});
